const statusColorMap = {
    WINNING: {
        color: "#53D337",
        background: "repeating-linear-gradient(-45deg, #53D337, #53D337 3px, rgba(83, 211, 55, 0.7) 3px, rgba(83, 211, 55, 0.7) 4px, #53D337 4px"
    },
    LOSING: {
        color: "#E9344A",
        background: "repeating-linear-gradient(-45deg, #E9344A, #E9344A 3px, rgba(233, 52, 74, 0.7), rgba(233, 52, 74, 0.7), #E9344A 4px"
    },
    EQUAL: {
        color: "#F3601B",
        background: "repeating-linear-gradient(-45deg, #F3601B, #F3601B 3px, rgba(243, 96, 27, 0.7), rgba(243, 96, 27, 0.7), #F3601B 4px"
    },
    TEMPLOSING: {
        color: "#F6B700",
        background: "repeating-linear-gradient(-45deg, #F6B700, #F6B700 3px, rgba(246, 183, 0, 0.7), rgba(246, 183, 0, 0.7), #F6B700 4px"
    },
};
const getTransformByX = (left) => {
    if (left === 0) {
        return "translateX(0%)";
    }
    return left > 98 ? "translateX(-100%)" : "translateX(-50%)";
};
export const getPointsLineWrapperStyles = (left) => ({
    position: "absolute",
    left: `${left}%`,
    top: "-3px",
    bottom: "-3px",
    zIndex: 1,
    borderLeft: "1px dashed #C5C5C5",
    height: "15px",
    fontWeight: 600
});
export const getCurrentPointBorderStyles = (status, left) => (Object.assign(Object.assign({}, getPointsLineWrapperStyles(Math.min(99.9, left))), { borderLeft: `1px solid ${statusColorMap[status].color}` }));
export const getPointsLineStyles = (left) => ({
    position: "absolute",
    top: "13px",
    transform: "translateX(-50%)",
    color: "#dadada",
    left: `${left}%`,
    fontWeight: 600,
});
export const getProgressBarWrapperStyles = () => ({
    height: "8px",
    background: "#373737",
    overflow: "hidden",
    borderRadius: "8px",
    fontSize: "12px",
    marginBottom: "20px"
});
export const getCurrentPointsWrapper = (status, left) => ({
    position: "absolute",
    left: `${left}%`,
    fontWeight: 600,
    bottom: "23px",
    zIndex: 1,
    transform: getTransformByX(left),
    transition: "color 0.3s",
    color: statusColorMap[status].color,
});
export const getProgressbarStyles = (status, width) => ({
    width: `${width}%`,
    height: "100%",
    background: statusColorMap[status].background,
    transition: "width 0.3s, background-color 0.3s",
    borderTopLeftRadius: "8px",
    borderBottomLeftRadius: "8px",
});
//# sourceMappingURL=variants.js.map